import { useIsDarkMode } from "@blueskydataplatform/shared-ui/hooks/use-is-dark-mode";
import { getBrandHomeUrl } from "@blueskydataplatform/shared-ui/theme/ui-branding";
import { useMcpProvider } from "@/providers/mcp-providers-context";

const Logo = ({ className }: { className?: string }) => {
  const darkMode = useIsDarkMode();
  const { provider } = useMcpProvider();
  const logo = darkMode ? provider?.logo?.dark : provider?.logo?.light;
  const brandHomeUrl = getBrandHomeUrl();

  if (!provider) {
    return null;
  }
  return (
    <a href={brandHomeUrl} className={className}>
      <div className="max-w-[250px] flex items-center justify-center">
        <img src={logo} alt={provider?.logo?.altText || "Provider Logo"} className="w-full h-full object-contain" />
      </div>
      {(provider?.id || "").toLowerCase() !== "vianexus" && (
        <span className="text-sm font-medium text-slate-900 dark:text-white">
          Powered by <span className="font-semibold text-primary dark:text-primary">viaNexus</span>
        </span>
      )}
    </a>
  );
};

export default Logo;
